import { default as default2 } from "./components/modules/overview/components/WishlistOverviewContainer.js";
export {
  default2 as WishlistContainer
};
//# sourceMappingURL=overview.js.map
